// App root. Provides the React Query client, auth bootstrap, and theme
// injection above the router outlet so every page inherits CSS variables
// before first render.

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { useState } from 'react';
import { router } from './router';
import { AuthProvider } from './auth/AuthProvider';
import { SidebarProvider } from './components/shell/SidebarContext';
import { ThemeBootstrap } from './theme/ThemeBootstrap';
import { PushBootstrap } from './hooks/PushBootstrap';

export function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            // Global default off: focus-refetch fires a parallel burst of
            // requests after token expiry, producing a flurry of 401 →
            // refresh → retry round-trips that show up as transient
            // network-tab noise. Hooks that need it (active job lists,
            // attachments, diary results) opt in locally.
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <SidebarProvider>
          <ThemeBootstrap />
          <PushBootstrap />
          <RouterProvider
            router={router}
            future={{ v7_startTransition: true }}
          />
        </SidebarProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}
